<template>
	<Row class="top-bar flex-align-center flex-justify-space-between width-100">
		<CollapsedNavigationAccordionMenu
			:nudge-right="1"
			:nudge-bottom="24"
			:to="inboxNavItem.to"
			:title="inboxNavItem.title"
			:settings="inboxNavItem.settings"
			:sections="inboxNavItem.sections"
			:titleSuffixComponent="inboxNavItem.titleSuffixComponent"
			:additionalItemSuffix="inboxNavItem.additionalItemSuffix"
			:collapsedModeNavButtonItem="inboxNavItem.collapsedModeNavButtonItem"
		>
			<template #activator="{ value }">
				<h3 class="reg">Inbox <v-icon :class="{ rotate: value }" class="ml-1 chevron">mdi-chevron-down</v-icon></h3>
			</template>
		</CollapsedNavigationAccordionMenu>
		<Row v-if="inbox">
			<AppAvatarGroup class="mr-12" :numToShow="3" :userIds="inbox.users" :groupIds="inbox.groups" tooltipDirection="bottom" />
			<component :id="inboxId" class="suffix" :is="settings.component" v-if="settings.component && hasPermissionToEditSettings" />
		</Row>
	</Row>
</template>
<script>
import { mapGetters } from 'vuex';
import InboxService from './inbox-service';
import { fetchInboxes } from '@/store/modules/inboxes/actions';
import { useInboxes, useInbox } from '@/store/modules/inboxes/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { getInboxNavItem } from '@/views/AppLayout/AppNavigation/app-navigation.const.js';
import CollapsedNavigationAccordionMenu from '@/views/AppLayout/AppNavigation/CollapsedNavigationAccordionMenu.vue';
export default {
	name: 'InboxTopBar',
	components: { CollapsedNavigationAccordionMenu },
	props: { inboxId: { type: [String, Number] } },
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ useInboxes, useInbox }),
		inbox() {
			return this.useInbox(this.inboxId);
		},
		settings() {
			return this.inboxNavItem.settings;
		},
		hasPermissionToEditSettings() {
			return !this.isInboxVirtual && this.settings.hasPermissionToEditSettingsFunc({ inbox: this.inbox, userId: this.user.id });
		},
		isInboxVirtual() {
			return InboxService.isInboxVirtual(this.inboxId);
		},
		inboxNavItem() {
			return getInboxNavItem({ useInboxesGetter: this.useInboxes, fetchInboxesAction: this.fetchInboxes });
		},
	},
	methods: { ...mapActionsShorthand({ fetchInboxes }) },
};
</script>
<style scoped lang="scss">
.top-bar {
	min-height: 75px;
	padding: 0px 20px 0px 50px;
	border-bottom: 1px solid var(--border-color);
}
.chevron {
	font-size: 20px;
	color: #7c828d;
	transition: var(--transition-time);
	&.rotate {
		transform: rotate(-180deg);
	}
}
</style>
